import React from 'react'
import {Link} from 'react-router-dom'

import * as S from './styles'

function ProductListHeading({title, side_link_txt, side_link_to}) {
    return (
        <S.Container>
            <S.UpperSection>
                <div><h1>{title}</h1></div>
                <div>
                    <Link to={side_link_to}>{side_link_txt}</Link>
                </div>
            </S.UpperSection>
        </S.Container>
    )
}

export default ProductListHeading
